import { Component, Input, OnChanges } from '@angular/core';
import { ResultListValueField } from '../../model/result-list-value-field';
import {
  CalculatorColorConfig,
  defaultCalculatorColorConfig,
} from '../../../calculator/calculator-components/simple-calculator/calculator-color-config';

@Component({
  selector: 'psc-user-investment',
  templateUrl: './user-investment.component.html',
})
export class UserInvestmentComponent implements OnChanges {
  @Input() solarCalculatorResult: UserInvestmentResult;
  @Input() smallTitle: boolean;

  defaultCurrency = 'EUR';

  userInvestmentValues: ResultListValueField[];
  @Input() colorConfig: CalculatorColorConfig = defaultCalculatorColorConfig;

  ngOnChanges() {
    this.setValues();
  }

  private setValues() {

    const currency = this.solarCalculatorResult.currency;

    this.userInvestmentValues = [
      {
        labelKey: 'investment',
        value: this.solarCalculatorResult.investment,
        unit: currency || this.defaultCurrency,
      },
      {
        labelKey: 'investment-return',
        value: this.solarCalculatorResult.investmentReturn,
        unit: '',
      },
      {
        labelKey: 'life-savings',
        value: this.solarCalculatorResult.lifeSavings,
        unit: currency || this.defaultCurrency,
      },
    ];

  }
}

export class UserInvestmentResult {
  currency?: string;
  investment: number | string;
  investmentReturn: number | string;
  lifeSavings: number | string;
}
